import React, { forwardRef } from "react";
import { Radio } from ".";
import { Field } from "../../../configuration";

interface RadioGroupProps extends Field {
  value?: string;
  onChange?: (newValue: string) => void;
}

const RadioGroup = forwardRef(
  ({ name, options, value, onChange }: RadioGroupProps, ref) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      if (onChange) {
        onChange(event.target.value);
      }
    };

    return (
      <fieldset className="flex flex-col lg:flex-row flex-wrap gap-5 max-w-full lg:max-w-fit">
        {options?.map((option, i) => (
          <Radio
            key={`${name}-${i}`}
            id={`${name}-${i}`}
            name={name}
            label={option.label}
            value={option.value}
            checked={value === option.value}
            onChange={handleChange}
          />
        ))}
      </fieldset>
    );
  }
);

export default RadioGroup;
